// WordPress holds the authoritative page slug, matched on the exact display name the
// backend sends. Only ITF's WP slug differs from what its name derives to; the FIN entry
// equals its derived slug and merely pins it.
const legacySlugOverrides = {
  'FIN Yritysrahoitus': 'fin-yritysrahoitus',
  'ITF Group JSC': 'itf-bulgaria'
}

const warnedNames = {}

// Public loan-originator page URL. The API's loan_originator_page_url always wins; the
// name-derived slug is a legacy fallback that only holds for names whose WP slug happens
// to match, so falling back is logged — the durable fix is backfilling that field in the
// backoffice.
export default function loanOriginatorPageUrl(name, url)
{
  if (url)
  {
    return url
  }
  if (!name)
  {
    console.warn('Loan originator has neither a page URL nor a name; no link rendered')
    return null
  }
  if (!warnedNames[name])
  {
    warnedNames[name] = true
    console.warn('Deriving loan originator page URL from name (backfill loan_originator_page_url):', name)
  }
  // NFD splits an accented letter into letter + combining mark so the mark can be dropped
  // on its own; without it the whole letter is lost and the URL misses the WordPress page.
  const slug = legacySlugOverrides[name] || name.trim()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
  return '/loan-originators/' + slug + '/'
}
